/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { FilterCountResponse } from '../models/FilterCountResponse';
import type { FilterCountsRequestDto } from '../models/FilterCountsRequestDto';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable()
export class GlobalFiltersService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param requestBody 
     * @returns FilterCountResponse Success
     * @throws ApiError
     */
    public getFilterCounts(
requestBody?: FilterCountsRequestDto,
): Observable<FilterCountResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/GlobalFilters/GetFilterCounts',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

}
